import { gql } from "@apollo/client";
import { MEMBER_INFO, ROOM_INFO, STAFF_INFO } from "../fragments";

export const GET_STAFF_LIST = gql`
  query staffList {
    staffList {
      ...staffInfo
    }
  }
  ${STAFF_INFO}
`;

export const GET_MEMBER_LIST = gql`
  query memberList {
    memberList {
      ...memberInfo
    }
  }
  ${MEMBER_INFO}
`;

export const FETCH_SETTINGS = gql`
  query fetchSettings {
    fetchSettings {
      isBugOpen
      isEnableCrobJob
      secretCode
    }
  }
`;

export const FETCH_COUNTRIES = gql`
  query getCountryList {
    getCountryList {
      id
      name
      imageUrl
    }
  }
`;

export const FETCH_ROOMS = gql`
  query roomListAdmin {
    roomListAdmin {
      ...roomInfo
    }
  }
  ${ROOM_INFO}
`;

export const GET_BOT_LIST = gql`
  query getBotList {
    getBotList {
      ...memberInfo
    }
  }
  ${MEMBER_INFO}
`;

export const FETCH_DASHBOARD = gql`
  query fetchDashboard {
    fetchDashboard {
      country
      room
      bet
      member
      transaction
    }
  }
`;

export const FETCH_ADMIN = gql`
  query adminList {
    adminList {
      id
      fullname
      username
      email
      branch {
        id
        name
      }
    }
  }
`;
